module.exports = require("./fr-CF");